import { testimonials } from "@/mocks/gossip";

const avatarTones = ["bg-primary-500", "bg-accent-500", "bg-secondary-600", "bg-foreground-800"];

export default function VoiceSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="shell">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-accent-600">Community</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">蹲点的网友怎么说</h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            来自不同圈层吃瓜党的真实反馈，也是我们持续蹲点的理由。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item, index) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100/60 p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-400" aria-hidden="true" />
              <blockquote className="mt-3 flex-1 text-sm leading-7 text-foreground-700">{item.text}</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-base text-background-50 ${avatarTones[index % avatarTones.length]}`}>
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <strong className="block text-sm font-medium text-foreground-900">{item.name}</strong>
                  <span className="mt-0.5 block text-[11px] text-foreground-500">{item.tag}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}